import React from 'react';
import { useAppSelector } from 'store';
import { TaskFilters as Filters, ChangeTaskFilter } from 'entities/task';

export const useTaskObserversFilter = (
    onFilteredData: ChangeTaskFilter,
    filteredData: Filters
) => {
    const { executorsForFilter } = useAppSelector((state) => state.tasksInformationReducer);

    const onChangeCheckbox = (value: number) => (e: React.SyntheticEvent) => {
        e.stopPropagation();

        if (filteredData.executors.includes(value)) {
            const updatedExecutors = filteredData.executors.filter((item) => item !== value);
            onFilteredData('executors', updatedExecutors);
        } else {
            const updatedExecutors = [...filteredData.executors, value];
            onFilteredData('executors', updatedExecutors);
        }
    };

    const resetFilterTypes = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        onFilteredData('executors', []);
    };

    const getSelectedItemText = () => {
        return executorsForFilter
            .filter((executor) => filteredData.executors.includes(executor.id))
            .map((executor) => executor.name)
            .join(', ');
    };
    const selectedItemText = getSelectedItemText();

    const isActiveTypesFilter = !!filteredData.executors.length;

    return {
        onChangeCheckbox,
        isActiveTypesFilter,
        resetFilterTypes,
        executorsForFilter,
        selectedItemText,
    };
};
